import { SidePanelRowTypes } from './types';

import styles from './side-panel-row.module.css';

export default function SidePanelRow({
  caption,
  resultBlock,
  children,
}: SidePanelRowTypes): React.JSX.Element {
  return (
    <div
      className={`${styles.sidePanelRow} ${
        resultBlock ? styles.resultBlock : ''
      }`}
    >
      <div className={styles.caption}>{caption}</div>
      {children}
    </div>
  );
}
